import { createPaintSwatches } from '../../ui/paintSwatches.js';
import { type PaintLinkState } from '../../materials/paintOverrides.js';
import type { ViewerTool } from './tool.js';
import type { ViewerContext } from '../context.js';

/** 차체색 스와치 도구. paint:change 를 emit 하고 paint:select 를 구독해 swatch 를 선택한다. */
export const paintTool: ViewerTool = {
  id: 'paint',
  enabled: (ctx) => ctx.rolesOn && !!ctx.config.palette,
  setup(ctx: ViewerContext): void {
    // Studio(배경) + Paint(차체) 오버라이드만 추려 RAV4 복원 실색 보존.
    const paintLink: PaintLinkState['overrides'] = new Map();
    for (const [hex, cats] of Object.entries(ctx.saved.paintOverrides)) {
      if (cats['Studio'] || cats['Paint']) {
        paintLink.set(hex, {
          ...(cats['Studio'] ? { Studio: cats['Studio'] } : {}),
          ...(cats['Paint'] ? { Paint: cats['Paint'] } : {}),
        });
      }
    }
    const linkState: PaintLinkState = {
      current: ctx.params.get('paint') ?? '#EFEFEA',
      overrides: paintLink,
    };
    // tuner 가 ctx 에서 linkState 를 찾을 수 있게 보관(같은 인스턴스 공유).
    ctx.paintLinkState = linkState;

    const { controller, el } = createPaintSwatches({
      scene: ctx.scene,
      palette: ctx.config.palette!,
      invalidate: ctx.invalidate,
      linkState,
      roleDefs: ctx.roleDefs,
      onPaintChange: () => ctx.events.emit('paint:change'),
    });
    // 기본 위치는 좌측 #app (Lexus). RAV4 는 뒤에 도는 accessoryMenu 가 우측 레일로 이관.
    document.getElementById('app')!.appendChild(el);
    ctx.paintPanel = { el, controller };
    ctx.events.on('paint:select', (hex) => controller.select(hex));
    ctx.invalidate();
  },
};
